import { useState, useEffect } from "react";
import { api } from "../api";

const S = {
  wrap: { fontFamily: "Syne, sans-serif" },
  title: { fontSize: 26, fontWeight: 700, color: "var(--text)", fontFamily: "Syne, sans-serif", margin: 0, letterSpacing: "-0.5px" },
  eyebrow: { fontSize: 10, letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 8, fontFamily: "Syne, sans-serif" },
  table: { width: "100%", borderCollapse: "collapse", marginTop: "1.5rem" },
  th: { fontFamily: "Syne, sans-serif", fontSize: 10, letterSpacing: "0.12em", color: "var(--mute)", textTransform: "uppercase", padding: "0.75rem 1rem", borderBottom: "0.5px solid var(--border)", textAlign: "left" },
  td: { fontFamily: "Syne, sans-serif", fontSize: 13, color: "var(--textSub)", padding: "0.85rem 1rem", borderBottom: "0.5px solid var(--border)" },
  tdName: { color: "var(--text)", fontWeight: 500 },
  empty: { textAlign: "center", color: "var(--mute)", padding: "3rem", fontSize: 13 }
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.getAudit().then(data => { setLogs(data); setLoading(false); }).catch(() => setLoading(false));
  }, []);
  const fmt = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString("es-ES") + " " + d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
  };
  return (
    <div style={S.wrap}>
      <div style={S.eyebrow}>Seguridad</div>
      <h1 style={S.title}>Registro de Auditoría</h1>
      {loading ? <p style={S.empty}>Cargando...</p> : logs.length === 0 ? (
        <p style={S.empty}>Sin actividad registrada</p>
      ) : (
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>Usuario</th>
              <th style={S.th}>Acción</th>
              <th style={S.th}>Elemento</th>
              <th style={S.th}>Fecha</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(l => (
              <tr key={l.id}>
                <td style={{...S.td, ...S.tdName}}>{l.user_name}</td>
                <td style={S.td}>{l.action}</td>
                <td style={S.td}>{l.item}</td>
                <td style={S.td}>{fmt(l.timestamp)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
